import {ViewMode} from '../../ui/components/common/data/DataView';
import {AppState} from '../reducer';

export const viewSelector = (state: AppState): ViewMode => state.viewReducer.presentationView;
